//------------------------------------------------------------------------------
// BFA10101G 共架申込一覧
//------------------------------------------------------------------------------
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DownloadIcon from '@mui/icons-material/Download';
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import {
  PositiveButton,
  PositiveButton2,
  StandardButton,
} from '@/components/atoms/Buttons/PositiveButton';

/**
 * 共架申込一覧 操作パネル
 */
function OperationPanel({
  editable,
  exportable,
  handleCreate, handleEdit,
  handleExport, handleBack,
}) {

  return (
    <Grid
      container
      spacing={1}
      sx={{
        mt: 1,
        justifyContent: "center",
        alignItems: "flex-start",
      }}
    >
      {/* 新規申込 */}
      <Grid item key="button-create">
        <PositiveButton
          variant="contained"
          size="large"
          startIcon={<AddIcon />}
          onClick={handleCreate}
        >
          <span>新規申込</span>
        </PositiveButton>
      </Grid>

      {/* 編集 */}
      <Grid item key="button-edit">
        <PositiveButton
          variant="contained"
          startIcon={<EditIcon />}
          size="large"
          disabled={!editable}
          onClick={handleEdit}
        >
          <span>編集</span>
        </PositiveButton>
      </Grid>

      {/* 一覧出力 */}
      <Grid item key="button-export">
        <PositiveButton2
          variant="contained"
          size="large"
          startIcon={<DownloadIcon/>}
          disabled={!exportable}
          onClick={handleExport}
        >
          <span>一覧出力</span>
        </PositiveButton2>
      </Grid>

      {/* 戻る */}
      <Grid item key="button-back">
        <StandardButton
          variant="contained"
          size="large"
          startIcon={<KeyboardReturnIcon/>}
          onClick={handleBack}
        >
          <span>戻る </span>
        </StandardButton>
      </Grid>
    </Grid>
  );
}

// プロパティ
OperationPanel.propTypes = {
  editable: PropTypes.bool.isRequired,      // 編集可否
  exportable: PropTypes.bool.isRequired,    // 一覧出力可否

  // イベントハンドラー
  handleCreate: PropTypes.func.isRequired,    // 新規申込
  handleExport: PropTypes.func.isRequired,    // 一覧出力
  handleEdit: PropTypes.func.isRequired,      // 編集
  handleBack: PropTypes.func.isRequired,      // 戻る
};

// エクスポート
export default OperationPanel;
